module.exports = __webpack_public_path__ + "jobs-2ec46bc8/bookmark-fill-11b369d6509a29726ee252f4b4411967.svg";